import React from 'react'

const color = {
  dark: '#5b5b5b',
  white: '#fff'
}

const CarKey = ({ outlineColor = 'dark' }) => (
  <svg
    width="72px"
    height="72px"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="text-primary block"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(1.000000, 7.000000)">
        <path
          d="M48.9885048,60 L32.9885048,60 C26.9235048,60 21.9885048,55.065 21.9885048,49 L21.9885048,11 C21.9885048,4.935 26.9235048,0 32.9885048,0 L48.9885048,0 C55.0535048,0 59.9885048,4.935 59.9885048,11 L59.9885048,49 C59.9885048,55.065 55.0525048,60 48.9885048,60 Z M32.9885048,2 C28.0265048,2 23.9885048,6.037 23.9885048,11 L23.9885048,49 C23.9885048,53.963 28.0265048,58 32.9885048,58 L48.9885048,58 C53.9505048,58 57.9885048,53.963 57.9885048,49 L57.9885048,11 C57.9885048,6.037 53.9505048,2 48.9885048,2 L32.9885048,2 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <path
          d="M31.9885048,15 C29.2315048,15 26.9885048,12.757 26.9885048,10 C26.9885048,7.243 29.2315048,5 31.9885048,5 C34.7455048,5 36.9885048,7.243 36.9885048,10 C36.9885048,12.757 34.7445048,15 31.9885048,15 Z M31.9885048,7 C30.3345048,7 28.9885048,8.346 28.9885048,10 C28.9885048,11.654 30.3345048,13 31.9885048,13 C33.6425048,13 34.9885048,11.654 34.9885048,10 C34.9885048,8.346 33.6415048,7 31.9885048,7 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <path
          d="M52.9885048,31 L28.9885048,31 C28.4365048,31 27.9885048,30.553 27.9885048,30 L27.9885048,26 C27.9885048,21.037 32.0265048,17 36.9885048,17 L44.9885048,17 C49.9505048,17 53.9885048,21.037 53.9885048,26 L53.9885048,30 C53.9885048,30.553 53.5395048,31 52.9885048,31 Z M29.9885048,29 L51.9885048,29 L51.9885048,26 C51.9885048,22.141 48.8485048,19 44.9885048,19 L36.9885048,19 C33.1285048,19 29.9885048,22.141 29.9885048,26 L29.9885048,29 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <path
          d="M44.9885048,55 L36.9885048,55 C32.0265048,55 27.9885048,50.963 27.9885048,46 L27.9885048,42 C27.9885048,41.447 28.4365048,41 28.9885048,41 L52.9885048,41 C53.5405048,41 53.9885048,41.447 53.9885048,42 L53.9885048,46 C53.9885048,50.963 49.9495048,55 44.9885048,55 Z M29.9885048,43 L29.9885048,46 C29.9885048,49.859 33.1285048,53 36.9885048,53 L44.9885048,53 C48.8485048,53 51.9885048,49.859 51.9885048,46 L51.9885048,43 L29.9885048,43 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <path
          d="M52.9885048,43 L28.9885048,43 C28.4365048,43 27.9885048,42.553 27.9885048,42 L27.9885048,30 C27.9885048,29.447 28.4365048,29 28.9885048,29 L52.9885048,29 C53.5405048,29 53.9885048,29.447 53.9885048,30 L53.9885048,42 C53.9885048,42.553 53.5395048,43 52.9885048,43 Z M29.9885048,41 L51.9885048,41 L51.9885048,31 L29.9885048,31 L29.9885048,41 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <path
          d="M42.9885048,51 L38.9885048,51 C37.8855048,51 36.9885048,50.103 36.9885048,49 L36.9885048,47 C36.9885048,45.897 37.8855048,45 38.9885048,45 L42.9885048,45 C44.0915048,45 44.9885048,45.897 44.9885048,47 L44.9885048,49 C44.9885048,50.103 44.0915048,51 42.9885048,51 Z M38.9885048,47 L38.9885048,49 L42.9895048,49 L42.9885048,47 L38.9885048,47 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <path
          d="M4.7565048,56.998 C4.2445048,56.998 3.7395048,56.863 3.2835048,56.601 L1.4755048,55.557 C0.0725048017,54.747 -0.416495198,52.944 0.386504802,51.536 L22.1195048,13.4 C22.3435048,13.005 22.8035048,12.812 23.2445048,12.928 C23.6825048,13.044 23.9885048,13.441 23.9885048,13.895 L23.9885048,25.895 C23.9885048,26.068 23.9435048,26.238 23.8585048,26.389 L7.3315048,55.501 C6.9395048,56.19 6.3025048,56.686 5.5365048,56.894 C5.2775048,56.963 5.0145048,56.998 4.7565048,56.998 Z M21.9885048,17.669 L2.1225048,52.525 C1.8635048,52.98 2.0205048,53.562 2.4745048,53.824 L4.2835048,54.868 C4.5055048,54.996 4.7645048,55.03 5.0115048,54.963 C5.2595048,54.896 5.4655048,54.736 5.5915048,54.513 L21.9885048,25.631 L21.9885048,17.669 Z"
          fill={color[outlineColor]}
          fillRule="nonzero"
        />
        <polygon
          fillOpacity="0.3"
          fill="currentColor"
          points="35.9885048 37 45.9885048 37 45.9885048 35 35.9885048 35"
        />
        <path
          d="M46.9885048,39 L34.9885048,39 C34.4365048,39 33.9885048,38.553 33.9885048,38 L33.9885048,34 C33.9885048,33.447 34.4365048,33 34.9885048,33 L46.9885048,33 C47.5405048,33 47.9885048,33.447 47.9885048,34 L47.9885048,38 C47.9885048,38.553 47.5395048,39 46.9885048,39 Z M35.9885048,37 L45.9885048,37 L45.9885048,35 L35.9885048,35 L35.9885048,37 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
        <polygon
          id="Path"
          fillOpacity="0.3"
          fill="currentColor"
          points="38.9885048 23 38.9885048 25 42.9895048 25 42.9885048 23"
        />
        <path
          d="M42.9885048,27 L38.9885048,27 C37.8855048,27 36.9885048,26.103 36.9885048,25 L36.9885048,23 C36.9885048,21.897 37.8855048,21 38.9885048,21 L42.9885048,21 C44.0915048,21 44.9885048,21.897 44.9885048,23 L44.9885048,25 C44.9885048,26.103 44.0915048,27 42.9885048,27 Z M38.9885048,23 L38.9885048,25 L42.9895048,25 L42.9885048,23 L38.9885048,23 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

export default CarKey
